export const ROOT = '/';
export const APP = '/app';

/**
 * OPEN ROUTES
 */
export const LOGIN = '/';
export const FORGOT_PASSWORD = '/forgot-password';
export const RESET_PASSWORD = '/reset-password/:token';

export const LOGOUT = '/logout';
export const NO_SERVER = `/noserver`;
export const NO_INTERNET = `/nointernet`;

export const COMMON_SETTING = `${APP}/settings`;

export const PROBLEMS_REPORTED = '/report-a-problem';
export const PROBLEMS_REPORTED_DETAILS = `${PROBLEMS_REPORTED}/detail`;
export const PROBLEMS_REPORTED_DETAILS_ROUTE = `${PROBLEMS_REPORTED}/detail/:id`;

// SIGNAL HUB ROUTES
export const MAP_VIEW = `${APP}/map`;
export const FRANCHISE_DETAILS = `${APP}/franchise/:id`;
export const FRANCHISE_LOT_DETAILS = `${APP}/franchise/:id/:lotId`;
export const KPI_DETAIL = `${APP}/kpi/:kpiId`;

export const COMMON_SETTING_PREFERENCES = `${COMMON_SETTING}?activeTab=preferences`;

export const PROFILE = `${APP}/settings/profile`;

export const NOTIFICATIONS = `${APP}/notifications`;

//QA testing route
export const QA_MODULE_ROUTE = `${APP}/qaModuleTest`;
